import {
  CheckInViaDriverRequest,
  TokenDetailsForLoginRequest,
} from "@/central-atoms/everest-fleet-pwa/requests";
import {
  CheckInViaDriverResponse,
  DriverCheckInRequestsResponse,
  GetLoginDetailsResponse,
  GetTyreBrandsResponse,
} from "@/central-atoms/everest-fleet-pwa/responses";
import { API_BASE_URL } from "@/constants";
import { apiClient } from "../apiClient";

class CheckInDriverService {
  static async getTyreBrands(): Promise<GetTyreBrandsResponse> {
    const response = await apiClient.get(`${API_BASE_URL}/tyre_brands`);
    return response.data;
  }

  static async getTokenDetailsForLogin(
    reqBody: TokenDetailsForLoginRequest
  ): Promise<GetLoginDetailsResponse> {
    const response = await apiClient.post(
      `${API_BASE_URL}/token_details_for_login`,
      reqBody
    );
    return response.data;
  }

  static async checkInViaDriver(
    reqBody: CheckInViaDriverRequest
  ): Promise<CheckInViaDriverResponse> {
    const response = await apiClient.post(
      `${API_BASE_URL}/check_in_via_driver`,
      reqBody
    );
    return response.data;
  }

  static async getCheckInRequests(): Promise<DriverCheckInRequestsResponse> {
    const response = await apiClient.get(`${API_BASE_URL}/check_in_requests`);
    return response.data;
  }
}

export default CheckInDriverService;
